import * as Lambda from '../../services/LambdaApi';
import { Registrant } from '../types/Registrant';

const listResidents = async ({ facilityId, search, page_no = 1, page_size = 50, sort, residentIds, residentId }: {
    facilityId: string;
    search?: string;
    page_no?: number;
    page_size?: number;
    sort?: Record<string, string>[];
    residentIds?: string[];
    residentId?: string; // selected resident, the directory then only lists residents in the same room type as them
}) => {
    const apiPath = `/s2l/${facilityId}/listResidents`;
    const filter: any = {
        IsActive: 1,
    };
    if (residentIds?.length) {
        filter._id = { $in: residentIds };
    }
    const params: any = {
        Filter: filter,
        Directory: true,
        QueryOptions: {
            page_no: page_no,
            page_size: page_size,
            sort: sort || [{ FirstName: "desc" }]
        },
        Search: search
    };
    if (!search) {
        delete params.Search;
    }
    if (residentId) {
        params.ResidentId = residentId;
    }
    const response = await Lambda.Post(apiPath, params, 'lambda');
    const residents = response?.Result?.Content?.Result;
    const totRecords = response?.Result?.Content?.TotRecords;
    if (!residents || totRecords === undefined || totRecords === null) {
        throw new Error('Invalid response from listResidents');
    }
    return {
        Residents: residents,
        TotRecords: totRecords
    };
};

const listAllResidents = async (filter) => {
    try {
        const { Facility: facilityId } = filter;
        if (!facilityId) throw new Error('facilityId is required');
        const apiPath = `/s2l/${facilityId}/listResidents`;
        const params = {
            Filter: {
                IsActive: 1,
                ...filter
            },
        };

        const response = await Lambda.Post(apiPath, params, 'lambda');
        if (!response || !response.Result || !response.Result.Success || !response.Result.Content) {
            throw new Error(response.Result.Error || `Error fetching resident's interests`);
        }
        return response.Result.Content as { Result: Registrant[]; TotRecords: number; };

    } catch (error) {
        throw new Error("Error fetching Resident list");
    }
};

const listResidentById = async (facilityId: string, residentId: string): Promise<Registrant | null> => {
    const apiPath = `/s2l/${facilityId}/listResidents`;
    const params = {
        Filter: {
            IsActive: 1,
            _id: residentId,
        },
        Directory: true,
        QueryOptions: {
            page_no: 1,
            page_size: 1,
        },
    };
    const response = await Lambda.Post(apiPath, params, 'lambda');
    const residents = response?.Result?.Content?.Result;
    if (residents && residents.length > 0) {
        return residents[0];
    }
    return null;
};

export { listResidents, listAllResidents, listResidentById };